import { useMemo } from "react";
import { BUTTON_LABELS, PERMISSIONS } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import {
  IStepTemplateResponse,
  IWorkOrderTemplateListItemResponse,
} from "@miplatform/types";
import { mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { usePermissions } from "@mibuildweb/hooks";
import { useTheme } from "@mui/material";
import { ConfigCard } from "../../components/ConfigCard/ConfigCard";

export function ConfigWorkOrderStepCard({
  step,
  workOrderTemplate,
  handleOpenDeleteModal = () => null,
}: ConfigWorkOrderStepItemProps) {
  const theme = useTheme();
  const { navigate } = useRouter();
  const { hasPermission } = usePermissions();

  const canDelete = hasPermission(PERMISSIONS.WORK_ORDER_TEMPLATE.DELETE);
  const canEdit = hasPermission(PERMISSIONS.WORK_ORDER_TEMPLATE.UPDATE);

  const navigateToEdit = () => {
    navigate(`${workOrderTemplate.id}/${step.id}`);
  };

  const menuActions = useMemo(() => {
    const actions = [];

    if (canEdit) {
      actions.push({
        label: BUTTON_LABELS.EDIT,
        icon: mdiPencilOutline,
        action: navigateToEdit,
      });
    }

    if (canDelete) {
      actions.push({
        label: BUTTON_LABELS.DELETE,
        icon: mdiTrashCanOutline,
        color: theme.palette.red.main,
        action: () => handleOpenDeleteModal(step),
      });
    }

    return actions;
  }, [canEdit, canDelete, step]);

  return (
    <ConfigCard
      title={step.title}
      additionalTitleText={[workOrderTemplate.name, step.areaName || "--"]}
      modifiedOn={step.modifiedOn}
      createdOn={step.createdOn}
      onClick={navigateToEdit}
      menuActions={menuActions}
    />
  );
}

interface ConfigWorkOrderStepItemProps {
  step: IStepTemplateResponse;
  workOrderTemplate: IWorkOrderTemplateListItemResponse & {
    stepTemplates: IStepTemplateResponse[];
  };
  handleOpenDeleteModal?: (step: IStepTemplateResponse) => void;
}
